/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmrClusterDefinition } from './emrClusterDefinition';
import { EmrClusterInstanceFleet } from './emrClusterInstanceFleet';
import { EmrStep } from './emrStep';
import { StatusChangeReason } from './statusChangeReason';
import { StatusTimeline } from './statusTimeline';


export interface EmrCluster { 
    id?: string;
    status?: string;
    statusChangeReason?: StatusChangeReason;
    statusTimeline?: StatusTimeline;
    namespace: string;
    emrClusterDefinitionName: string;
    emrClusterName: string;
    /**
     * The AWS account number, without dashes, where Amazon EMR service is running in
     */
    accountId?: string;
    activeStep?: EmrStep;
    step?: EmrStep;
    dryRun?: boolean;
    emrClusterCreated?: boolean;
    emrClusterDefinition?: EmrClusterDefinition;
    /**
     * Describes the EC2 instances and instance configurations for clusters that use the instance fleet configuration. The instance                   fleet configuration is available only in Amazon EMR versions 4.8.0 and later, excluding 5.0.x versions                
     */
    instanceFleets?: Array<EmrClusterInstanceFleet>;
}
